module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryout-form"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Tryout',
          to: {
            path: '/tryouts'
          }
        },
        {
          text: !_vm.$route.query.id ? 'Tambah Tryout' : 'Ubah Tryout'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("\n        " + _vm._s(!_vm.$route.query.id ? "Tambah Tryout" : "Ubah Tryout") + "\n    ")]), _vm._v(" "), _c('v-card', [_c('v-stepper', {
    staticClass: "pa-0",
    attrs: {
      "flat": "",
      "color": "blew"
    },
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, [_c('v-card-text', [_c('v-row', {
    staticStyle: {
      "box-shadow": "0px 1px 0px rgba(0, 0, 0, 0.05)"
    },
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "7"
    }
  }, [_c('v-stepper-header', {
    staticStyle: {
      "box-shadow": "none"
    },
    attrs: {
      "flat": ""
    }
  }, [_c('v-stepper-step', {
    attrs: {
      "complete": _vm.step > 1,
      "step": "1"
    }
  }, [_vm._v("\n                                Membuat Tryout\n                            ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "complete": _vm.step > 2,
      "step": "2"
    }
  }, [_vm._v("\n                                Membuat Subtest\n                            ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "3"
    }
  }, [_vm._v("\n                                Preview\n                            ")])], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-col', [_c('v-layout', [_c('v-flex', [(
    _vm.statusTryout == 'REVIEW' &&
    _vm.step == 3
  ) ? _c('v-btn', {
    staticClass: "pull-right mt-5 mr-4",
    attrs: {
      "text": "",
      "color": "grey"
    },
    on: {
      "click": function($event) {
        _vm.statusTryout = 'DRAFT'
      }
    }
  }, [_vm._v("\n                                    Kembali ke Draft\n                                ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', [(
    _vm.statusTryout == 'REVIEW' &&
    _vm.step == 3
  ) ? _c('v-btn', {
    staticClass: "pull-right mt-5 mr-4 darkGreen--text",
    attrs: {
      "elevation": "0",
      "color": "backgroundGreen"
    },
    on: {
      "click": function($event) {
        _vm.statusTryout = 'PUBLISH'
      }
    }
  }, [_vm._v("\n                                    Publish Tryout\n                                ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', [(
    _vm.statusTryout == 'DRAFT' && _vm.step == 3
  ) ? _c('v-btn', {
    staticClass: "pull-right mt-5 mr-4 darkYellow--text",
    attrs: {
      "elevation": "0",
      "color": "backgroundYellow"
    },
    on: {
      "click": function($event) {
        _vm.statusTryout = 'REVIEW'
      }
    }
  }, [_vm._v("\n                                    Ubah ke Review\n                                ")]) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-stepper-items', [_c('v-stepper-content', {
    attrs: {
      "step": "1"
    }
  }, [(_vm.step === 1) ? _c('app-tryoutform', {
    on: {
      "completed": function($event) {
        return _vm.goToNextStep()
      },
      "uncompleted": function($event) {
        _vm.step--
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "2"
    }
  }, [_c('app-subtestlist', {
    on: {
      "completed": function($event) {
        return _vm.goToNextStep()
      },
      "uncompleted": function($event) {
        _vm.step--
      }
    }
  })], 1), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "3"
    }
  }, [_c('app-tryoutreview', {
    attrs: {
      "statusReview": _vm.statusTryout
    },
    on: {
      "completed": function($event) {
        return _vm.goToNextStep()
      },
      "uncompleted": function($event) {
        _vm.step--
      },
      "statusReview": function($event) {
        _vm.statusTryout = $event
      }
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57e769b3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/tryout/components/Form.vue
// module id = 2097
// module chunks = 1